import { render } from "./AmazonListingView.vue?vue&type=template&id=1e8ddc31&scoped=true"
import script from "./AmazonListingView.vue?vue&type=script&lang=js"
export * from "./AmazonListingView.vue?vue&type=script&lang=js"

import "./AmazonListingView.vue?vue&type=style&index=0&id=1e8ddc31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8ddc31"]])

export default __exports__